import React, { useState, useEffect } from "react";
import Loader from "../wrappers/Loader";
import { Header } from "../wrappers/Header";
import video from "../assets/img/kule_web.mp4";
import img1 from "../assets/img/img1.png";
import img2 from "../assets/img/kule.jpg";
import img3 from "../assets/img/img3.png";
import img4 from "../assets/img/img4.png";
import img5 from "../assets/img/1.jpg";
import Marquee from "react-fast-marquee";
import Footer from "../wrappers/Footer";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import home from "../data/home.json";
import ReactHtmlParser from "react-html-parser";

const Home = ({duyurular,home}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [hoveredResident, setHoveredResident] = useState(null);

  const handleMouseEnter = (resident) => {
    setHoveredResident(resident.duyuru_no);
  };

  const handleMouseLeave = () => {
    setHoveredResident(null);
  };


  const [resultLast, setResultLast] = useState([]);
  const [resultLastHome, setResultLastHome] = useState([]);

  useEffect(() => {
    setResultLast(duyurular.slice(-3));
  }, [duyurular]);

  useEffect(() => {
    setResultLastHome(home);
  }, [home]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 4200);

    return () => clearTimeout(timer);
  }, []);

  const handleClick = () => {
    window.scrollTo({
      top: window.scrollY + window.innerHeight * 1.3,
      behavior: "smooth",
    });
  };
  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          {" "}
          <Header />
          <div className="position-relative overflow-hidden">
            <video
              className="home-video"
              src={video}
              autoPlay
              muted
              loop
            ></video>
            <div className="video-area">
              <h1>
                Ankara'nın İş Kalbinde Yükselen Çözümler: <br />
                Koç Kuleleri!
              </h1>
              <button className="button-type mt-5" onClick={handleClick}>
                KEŞFET
              </button>
            </div>
          </div>
          <div className="p-lg-5">
            {" "}
            <h1 className="text-center text-white mt-5 mb-5">
              KOÇ KULELERİ B BLOK
            </h1>
            <div className=" container  text-white ">
              <div className="d-lg-flex">
                {" "}
                <div className="col-lg-8 col-12  section-bg p-3 d-flex align-items-center flex-column justify-content-center">
                {ReactHtmlParser(resultLastHome.text_1)}
                </div>
                <div className="col-lg-4 col-12 d-flex justify-content-lg-end justify-content-center mt-lg-0 mt-5 align-items-center">
                  <img className="responsive-img-style" src={img1} alt=""></img>
                </div>
              </div>
              <Marquee className="marque-text mt-3 mb-3">
              {ReactHtmlParser(resultLastHome.text_2)}
              </Marquee>
              <div className="d-lg-flex">
                {" "}
                <div className="col-lg-4 col-12 mb-lg-0 mb-5 d-flex justify-content-lg-start justify-content-center align-items-center">
                  <img
                  alt=""
                    className="responsive-img-style radius-img"
                    src={img2}
                  ></img>
                </div>
                <div className="col-lg-8  col-12 section-bg p-3 d-flex align-items-center flex-column justify-content-center">
                {ReactHtmlParser(resultLastHome.text_3)}
                </div>
              </div>{" "}
              <div className="col-12  section-bg p-3 d-flex align-items-center flex-column justify-content-center mt-4">
              {ReactHtmlParser(resultLastHome.text_4)}
              </div>
              <div className="col-12 mt-4 position-relative d-flex justify-content-center">
                <img className="text-main-img" src={img3} alt=""/>
                <div className="text-main-center text-center text-white">
                  <h1>KOÇ KULELERİ'NDE İŞ, KONFOR VE PRESTİJ BIR ARADA!</h1>
                </div>
              </div>
              <div className="d-lg-flex mt-4">
                {" "}
                <div className="col-lg-7 col-12 section-bg p-3 d-flex align-items-center flex-column justify-content-center">
                {ReactHtmlParser(resultLastHome.text_5)}
                </div>{" "}
                <div className="col-lg-5 col-12 d-flex justify-content-lg-end justify-content-center mt-lg-0 mt-5 d-flex align-items-center">
                  <img className="responsive-img-style" src={img4}></img>
                </div>
              </div>
              <div className="col-12  section-bg p-3 d-flex  flex-column justify-content-center mt-4">
              {ReactHtmlParser(resultLastHome.text_6)}
              </div>
            </div>
          </div>{" "}
          <div className="bg-build mb-5">
            <div className="container">
              <div className="text-white mt-4">
                <h1 className="mb-4">Duyurular</h1>
                <div className=" mt-5 d-flex flex-wrap justify-content-around">
                {resultLast.map((key, index) => (
                    <div
                    key={index}
                      className="col-lg-4 sakin-main col-md-6 p-md-1 position-relative col-12 mb-3 duyuru-main d-flex justify-content-center align-items-center"
                      onMouseEnter={() => handleMouseEnter(key)}
                      onMouseLeave={handleMouseLeave}
                    >
                      <img
                        className="text-main-img"
                        src={(() => {
                          if (!key.image) return '';
                          if (key.image.startsWith('http')) return key.image;
                          if (key.image.startsWith('logo/')) return `https://kuleadmin.kulebblok.com.tr/public/${key.image}`;
                          if (key.image.startsWith('uploads/')) return `https://kuleadmin.kulebblok.com.tr/${key.image}`;
                          // Eğer sadece dosya adı varsa, public/ klasörüne yönlendir
                          if (!key.image.includes('/')) {
                            // blog_inner ile başlayan veya genel resim dosyaları için public/ kullan
                            if (key.image.startsWith('blog_inner') || 
                                key.image.match(/\.(png|jpg|jpeg|gif|webp|svg)$/i)) {
                              return `https://kuleadmin.kulebblok.com.tr/public/${key.image}`;
                            }
                            // Diğer durumlarda uploads/duyurus/ kullan
                            return `https://kuleadmin.kulebblok.com.tr/uploads/duyurus/${key.image}`;
                          }
                          return `https://kuleadmin.kulebblok.com.tr/${key.image}`;
                        })()}
                        onError={(e) => {
                          e.target.style.display = 'none';
                          console.error('Resim yüklenemedi:', key.image);
                        }}
                        alt=""
                      />
                      <div
                        className={`text-main-center-blog text-white ${
                          hoveredResident === key.duyuru_no ? "hovered" : ""
                        }`}
                      >
                        <a
                          target="_blank"
                          rel="noreferrer"
                          href={`/duyurular/${encodeURIComponent(
                            key.title.replace(/\s/g, "-")
                          )}`}
                        >
                          <div className="content">
                            {" "}
                            <h4>{key.title}</h4>
                            <p>{key.date}</p>
                          </div>
                        </a>

                        {hoveredResident === key.duyuru_no && (
                          <a
                            target="_blank"
                            rel="noreferrer"
                            href={`/duyurular/${encodeURIComponent(
                              key.title.replace(/\s/g, "-")
                            )}`}
                          >
                            <button className="button-type-two ">
                              {" "}
                              Daha Fazla
                            </button>
                          </a>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
                <div className="col-12 d-flex justify-content-center">
                  <a target="_blank" href="/duyurular">
                    {" "}
                    <button className="button-type-two mt-3 w-100">
                      DAHA FAZLASINI GÖR
                    </button>
                  </a>
                </div>
                <div className="col-12 mt-5 position-relative">
                  <img className="text-main-img radius-img" src={img5} alt=""/>
                  <div className="text-main-center text-center text-white">
                    <h1>
                      Koç Kuleleri ile İletişime Geçin: İşiniz İçin En Doğru
                      Adres
                    </h1>
                    <a href="/iletisim" target="_blank">
                      <button className="button-type-two mt-lg-5 mt-0">
                        İletişim
                      </button>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </>
      )}
    </>
  );
};

Home.propTypes = {
  duyurular: Home.array,
  home: Home.array
};

const mapStateToProps = (state) => {
  return {
    duyurular: state.duyurularData.duyurular,
    home: state.homeData.home,
  };
};

export default connect(mapStateToProps)(Home);
